import { PropertiesList } from "./components/PropertiesList";
import { Typography } from "common/components/Typography";
import { useAppraiser } from "./hooks/auth.hooks";
import { AppraiserRole } from "./types/appraiser.types";
import { useTranslation } from "react-i18next";
import { CreateValuationButton } from "./components/propertyCRUD/CreateValuationButton";

function App() {
  const { t } = useTranslation();
  const { data: appraiser, isLoading } = useAppraiser();

  if (isLoading) {
    return null;
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant="h1">{t("propertyList.title")}</Typography>
        {appraiser?.role !== AppraiserRole.SPECTATOR && (
          <CreateValuationButton />
        )}
      </div>
      <PropertiesList />
    </div>
  );
}

export default App;
